import {
  useEffect,
  useState,
} from 'react';
import {
  Edit3 as Edit3Icon,
  Lock,
  RefreshCcw,
  Trash2 as Trash2Icon,
  Unlock,
} from 'react-feather';
import moment from 'moment';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
  useDispatch,
  useSelector,
} from 'react-redux';
import { KhoAction } from 'src/actions/kho.action';
import {
  CONFIRM_TYPES,
  DEFAULT_ROW_PER_PAGE,
  ROW_PER_PAGE_OPTIONS,
  MAXIMUM_IMAGES,
} from 'src/utils/constants';
import { getKhoStatus } from 'src/utils/utils';
import ConfirmDialog from '../ConfirmDialog';
import {
  Box,
  Card,
  Checkbox,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
  IconButton,
  Button,
  Select as Select1,
  MenuItem,
} from '@material-ui/core';
import CreateEditDialog from './CreateEditDialog';

import numeral from 'numeral';

import { Settings, Download, Upload, Cached } from '@material-ui/icons';
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import KhophieuView from '../khophieu-detail/KhophieuView';

const KhoLookupDetail = ({ ...rest }) => {
  const maximumImages = MAXIMUM_IMAGES;
  const dispatch = useDispatch()
  const [selectedKhoIds, setSelectedKhoIds] = useState([]);
  const [limit, setLimit] = useState(DEFAULT_ROW_PER_PAGE);
  const [page, setPage] = useState(0);
  const { role } = useSelector(state => state.profile);
  const { 
    items, 
    total, 
    filter, 
    ton_hien_tai, 
    ton_dau_ky, 
    nhap_trong_ky, 
    xuat_trong_ky, 
    ton_cuoi_ky, 
    ton_hien_tai_gia_tri, 
    ton_dau_ky_gia_tri, 
    nhap_trong_ky_gia_tri, 
    xuat_trong_ky_gia_tri, 
    ton_cuoi_ky_gia_tri,
  } = useSelector(state => state.kho);
  const [confirm, setConfirm] = useState(false);
  const [confirmType, setConfirmType] = useState("");
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");
  const [selected, setSelected] = useState({});
  const [open, setOpen] = useState(false);
  const [openKhophieuView, setOpenKhophieuView] = useState(false);
  const [_khos, setKhos] = useState(null);
  const [_khophieu, setKhophieu] = useState(null);

  const trangThaiOptions = [
    { value: 'cho_duyet', label: 'Chờ duyệt' },
    { value: 'da_duyet', label: 'Đã duyệt' },
    { value: 'tu_choi', label: 'Từ chối' }
  ];

  useEffect(() => {
    const payload = {
      ...filter,
      limit: limit,
      page: page,
    };
    dispatch(KhoAction.updateFilter(payload));
    dispatch(KhoAction.list(page, limit))
  }, [page, limit])

  const handleSelectAll = (event) => {
    let newSelectedKhoIds;

    if (event.target.checked) {
      newSelectedKhoIds = items.map((kho) => kho.id);
    } else {
      newSelectedKhoIds = [];
    }

    setSelectedKhoIds(newSelectedKhoIds);
  };

  const handleSelectOne = (event, id) => {
    const selectedIndex = selectedKhoIds.indexOf(id);
    let newSelectedKhoIds = [];

    if (selectedIndex === -1) {
      newSelectedKhoIds = newSelectedKhoIds.concat(selectedKhoIds, id);
    } else if (selectedIndex === 0) {
      newSelectedKhoIds = newSelectedKhoIds.concat(selectedKhoIds.slice(1));
    } else if (selectedIndex === selectedKhoIds.length - 1) {
      newSelectedKhoIds = newSelectedKhoIds.concat(selectedKhoIds.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelectedKhoIds = newSelectedKhoIds.concat(
        selectedKhoIds.slice(0, selectedIndex),
        selectedKhoIds.slice(selectedIndex + 1)
      );
    }

    setSelectedKhoIds(newSelectedKhoIds);
  };

  const handleLimitChange = (event) => {
    setLimit(event.target.value);
    setPage(0);
  };

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  const handleConfirmOpen = (type, kho) => {
    setSelected(kho);
    setConfirmType(type);
    if (confirmType === CONFIRM_TYPES.DELETE) {
      setTitle("Xoá bản ghi")
      setContent(`Xác nhận xoá bản ghi `)
    }
    setConfirm(true);
  };

  const onConfirm = () => {
    setConfirm(false);
    if (confirmType === CONFIRM_TYPES.DELETE) {
      dispatch(KhoAction.del(selected.id))
      return;
    }
  }

  const handleConfirmClose = () => {
    setConfirm(false);
  };

  const onSelected = (id) => {
    dispatch(KhoAction.findOne(id));
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleOpenKhophieuView = (khos, khophieu) => {
    setKhos(khos);
    setKhophieu(khophieu);
    setOpenKhophieuView(true);
  };

  const handleCloseKhophieuView = () => {
    setOpenKhophieuView(false);
  };

  const approve = async (id, trang_thai_duyet) => {
    const question = trang_thai_duyet == 1 ? "Xác nhận duyệt đơn này?" : "Xác nhận từ chối đơn này?" ;
    if (window.confirm(question)) {
      try {
        const response = await dispatch(KhoAction.approve(id, { trang_thai_duyet }));
        if (typeof response.channel !== 'undefined') alert("[Thông báo từ '"+response.channel+"']\n"+response.message+(response.status != "Unknown" ? (" ("+response.status+")") : ""));
        else if (typeof response.code !== 'undefined' && typeof response.msg !== 'undefined') alert("[Lỗi]\n"+response.msg)
      } catch (error) {
        if (typeof error.code !== 'undefined' && typeof error.msg !== 'undefined') alert("[Lỗi]\n"+error.msg)
      }
    } else {
      
    }
  };

  const setTrangThai = async (id, trang_thai, trang_thai_text) => {
    const question = "Xác nhận đặt trạng thái '" + trang_thai_text + "'?";
    if (window.confirm(question)) {
      try {
        // const response = await dispatch(KhoAction.setTrangThai(id, { trang_thai }));
        // if (typeof response.channel !== 'undefined') alert("[Thông báo từ '"+response.channel+"']\n"+response.message+(response.status != "Unknown" ? (" ("+response.status+")") : ""));
        // else if (typeof response.code !== 'undefined' && typeof response.msg !== 'undefined') alert("[Lỗi]\n"+response.msg)
        
          dispatch(KhoAction.update(id, { 
          trang_thai,
        }))
      } catch (error) {
        if (typeof error.code !== 'undefined' && typeof error.msg !== 'undefined') alert("[Lỗi]\n"+error.msg)
      }
    } else {
      
    }
  };

  const copyToClipboard = (content) => {
    navigator.clipboard
      .writeText(content)
      .then(() => {
        console.log('String copied to clipboard:', content);
        // showToast('success', `Đã copy: ${content}`);
      })
      .catch((error) => {
        console.error('Unable to copy string:', error);
        // showToast('error', `Lỗi không thể copy: ${content}`);
      });
  };

  const setColor = (value) => {
      if (value == 'cho_duyet') return 'orange';
      else if (value == 'da_duyet') return 'green';
      else if (value == 'tu_choi') return 'red';
      else if (value == 'positive') return 'green';
      else if (value == 'negative') return 'red';
      else return '#000000';
  };

  return (
    <Card {...rest} style={{ width: "100%"}}>
      <PerfectScrollbar>
        <Box sx={{ minWidth: 1050 }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>
                  #
                </TableCell>
                <TableCell>
                  Phiếu
                </TableCell>
                <TableCell>
                  Sản phẩm
                </TableCell>
                <TableCell>
                  Nhập (+) / Xuất (-)
                </TableCell>
                <TableCell>
                  Đơn giá
                </TableCell>
                <TableCell>
                  Giá trị
                </TableCell>
                <TableCell>
                  Ghi chú
                </TableCell>
                <TableCell>
                  Ngày tạo
                </TableCell>
                <TableCell>
                  Người nhập
                </TableCell>
                <TableCell>
                  Người cập nhật cuối
                </TableCell>
                <TableCell>
                  Người duyệt
                </TableCell>
                <TableCell>
                  Trạng thái
                </TableCell>
                <TableCell>
                  Thao tác
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {items && Object.values(items).length > 0 && items.slice(page * limit, page * limit + limit).map((kho, index) => (
                <TableRow
                  hover
                  key={kho.id}
                  selected={selectedKhoIds.indexOf(kho.id) !== -1}
                >
                  <TableCell>
                    {page * limit + index + 1}
                  </TableCell>
                  <TableCell>
                    <Button
                      style={{ padding: 0 }}
                      // onClick={() =>
                      //   handleOpenKhophieuView(khophieu.khos, typeof kho.khophieu_ref !== 'undefined' ? kho.khophieu_ref : null)
                      // }
                    >
                      {typeof kho.khophieu_ref !== 'undefined' && kho.khophieu_ref.so_phieu}
                    </Button>
                    <Button
                      color="primary"
                      variant="contained"
                      onClick={() =>
                        copyToClipboard(typeof kho.khophieu_ref !== 'undefined' && kho.khophieu_ref.so_phieu)
                      }
                      style={{height: '20px', padding: 0, marginTop: 0, width: '20px', minWidth: '20px', marginLeft: '5px', backgroundColor: 'orange', fontWeight: 'normal', fontSize: '20px'}}
                    >
                      {<ContentCopyIcon style={{ color: "white" }} />}
                    </Button>
                  </TableCell>
                  <TableCell>
                    <Typography
                      color="textPrimary"
                      variant="body1"
                    >
                      <span style={{color: 'blue'}}>
                        [{kho.loai_san_pham_text == "xe_may_dien" && <span style={{ }}>Xe máy điện</span>}
                        {kho.loai_san_pham_text == "xe_dap_dien" && <span style={{ }}>Xe đạp điện</span>}
                        {kho.loai_san_pham_text == "ac_quy" && <span style={{ }}>Ắc quy</span>}
                        {kho.loai_san_pham_text == "pin" && <span style={{ }}>Pin</span>}
                        {kho.loai_san_pham_text == "phu_tung" && <span style={{ }}>Phụ tùng</span>}
                        {kho.loai_san_pham_text == "khac" && <span style={{ }}>Khác</span>}]
                      </span>
                      <br></br>
                      <span style={{color: 'green', fontWeight: 'bold'}}>{kho.ten_san_pham_text}</span>
                      <br></br>
                      <span style={{color: 'red', fontStyle: 'italic'}}>({kho.phien_ban_san_pham_text})</span>
                      {kho.ma_san_pham && <>
                        <br></br>
                        <br></br>
                        <span style={{fontWeight: 'bold'}}>- Mã sản phẩm: </span><span>{kho.ma_san_pham}</span>
                      </>}
                      {kho.thong_tin_them && <>
                        <br></br>
                        <br></br>
                        <span style={{fontWeight: 'bold'}}>- Thông tin thêm: </span><span>{kho.thong_tin_them}</span>
                      </>}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      color="textPrimary"
                      variant="body1"
                    >
                      <span style={{fontWeight: 'bold', color: setColor(kho.nhap_xuat < 0 ? 'negative' : 'positive')}}>{numeral(kho.nhap_xuat).format('0,0')}</span>
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      color="textPrimary"
                      variant="body1"
                    >
                      <span style={{fontWeight: 'bold', color: 'blue'}}>{numeral(kho.don_gia).format('0,0')}</span>
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      color="textPrimary"
                      variant="body1"
                    >
                      <span style={{fontWeight: 'bold', color: setColor(kho.nhap_xuat < 0 ? 'negative' : 'positive')}}>{numeral(kho.don_gia * kho.nhap_xuat).format('0,0')}</span>
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      color="textPrimary"
                      variant="body1"
                    >
                      {kho.ghi_chu}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      color="textPrimary"
                      variant="body1"
                    >
                      {moment(kho.thoi_diem_tao_dong_bo).format('DD-MM-YYYY HH:mm:ss')}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      color="textPrimary"
                      variant="body1"
                    >
                      {kho.username_nguoi_nhap}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      color="textPrimary"
                      variant="body1"
                    >
                      {kho.username_chinh_sua_cuoi_cung}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      color="textPrimary"
                      variant="body1"
                    >
                      {kho.username_nguoi_duyet}
                      <br></br>
											{kho.thoi_diem_duyet ? '(' + moment(kho.thoi_diem_duyet).format('DD-MM-YYYY HH:mm:ss') + ')' : ''}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      color=""
                      variant="body1"
                    >
                      {1 < 0 && role.priority < 3 && kho.trang_thai == 'cho_duyet' ? <>
                        <Select1
                          style={{
                            fontSize: '14px',
                            width: '120px',
                            marginBottom: '15px',
                            color: setColor(kho.trang_thai)
                          }}
                          variant="outlined"
                          value={kho.trang_thai}
                          onChange={(e) => {
                            const value = e.target.value;
                            const text = trangThaiOptions.find(opt => opt.value === value)?.label || '';
                            setTrangThai(kho.id, value, text);
                          }}
                        >
                          {trangThaiOptions.map((opt) => (
                            <MenuItem
                              key={opt.value}
                              value={opt.value}
                              style={{ color: setColor(opt.value) }}
                            >
                              {opt.label}
                            </MenuItem>
                          ))}
                        </Select1>
                      </> : <>
                        {kho.trang_thai == "cho_duyet" && <span style={{ color: setColor('cho_duyet'), paddingLeft: 5 }}>Chờ duyệt</span>}
                        {kho.trang_thai == "da_duyet" && <span style={{ color: setColor('da_duyet'), paddingLeft: 5 }}>Đã duyệt</span>}
                        {kho.trang_thai == "tu_choi" && <span style={{ color: setColor('tu_choi'), paddingLeft: 5 }}>Từ chối</span>}
                      </>}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    {kho.trang_thai == "cho_duyet" && <IconButton aria-label="edit" onClick={() => onSelected(kho.id)}>
                      <Edit3Icon color='green' />
                    </IconButton>}
                    {role.priority < 3 && <IconButton aria-label="delete" onClick={() => handleConfirmOpen(CONFIRM_TYPES.DELETE, kho)}>
                      <Trash2Icon color='red' />
                    </IconButton>}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Box>
      </PerfectScrollbar>
      <PerfectScrollbar>
        <Box sx={{ minWidth: 1050 }}>
          <Table className='table-border-none' style={{margin: '15px 0'}}>
            <TableBody>
              <TableRow>
                <TableCell>
                  <span style={{color: 'teal', fontWeight: 'bold'}}>SỐ LƯỢNG: </span>
                </TableCell>
                <TableCell>
                  <span>Tồn hiện tại: <span style={{color: 'purple', fontWeight: 'bold'}}>{numeral(ton_hien_tai).format('0,0')}</span></span>
                </TableCell>
                <TableCell>
                  <span>Tồn đầu kỳ: <span style={{color: 'blue', fontWeight: 'bold'}}>{numeral(ton_dau_ky).format('0,0')}</span></span>
                </TableCell>
                <TableCell>
                  <span>Nhập trong kỳ: <span style={{color: 'green', fontWeight: 'bold'}}>{numeral(nhap_trong_ky).format('0,0')}</span></span>
                </TableCell>
                <TableCell>
                  <span>Xuất trong kỳ: <span style={{color: 'red', fontWeight: 'bold'}}>{numeral(xuat_trong_ky).format('0,0')}</span></span>
                </TableCell>
                <TableCell>
                  <span>Tồn cuối kỳ: <span style={{color: 'blue', fontWeight: 'bold'}}>{numeral(ton_cuoi_ky).format('0,0')}</span></span>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>
                  <span style={{color: 'teal', fontWeight: 'bold'}}>GIÁ TRỊ: </span>
                </TableCell>
                <TableCell>
                  <span>Tồn hiện tại: <span style={{color: 'purple', fontWeight: 'bold'}}>{numeral(ton_hien_tai_gia_tri).format('0,0')}</span></span>
                </TableCell>
                <TableCell>
                  <span>Tồn đầu kỳ: <span style={{color: 'blue', fontWeight: 'bold'}}>{numeral(ton_dau_ky_gia_tri).format('0,0')}</span></span>
                </TableCell>
                <TableCell>
                  <span>Nhập trong kỳ: <span style={{color: 'green', fontWeight: 'bold'}}>{numeral(nhap_trong_ky_gia_tri).format('0,0')}</span></span>
                </TableCell>
                <TableCell>
                  <span>Xuất trong kỳ: <span style={{color: 'red', fontWeight: 'bold'}}>{numeral(xuat_trong_ky_gia_tri).format('0,0')}</span></span>
                </TableCell>
                <TableCell>
                  <span>Tồn cuối kỳ: <span style={{color: 'blue', fontWeight: 'bold'}}>{numeral(ton_cuoi_ky_gia_tri).format('0,0')}</span></span>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </Box>
      </PerfectScrollbar>
      <div style={{margin: '0 10px'}}>
        <Typography
          color="textPrimary"
          variant="body1"
        >
          <span style={{color: 'red', fontSize: '85%', fontWeight: 'bold'}}>
            * Lưu ý: Các chỉ số thống kê trên đây chỉ tính toán dựa trên các mục ĐÃ DUYỆT và chỉ thay đổi khi dùng bộ lọc đối với các mục sau:<br></br>
            - LOẠI SẢN PHẨM<br></br>
            - TÊN SẢN PHẨM<br></br>
            - PHIÊN BẢN SẢN PHẨM<br></br>
            - THỜI ĐIỂM BẮT ĐẦU / KẾT THÚC<br></br>
          </span>
        </Typography>
      </div>
      <TablePagination
        component="div"
        count={total}
        onPageChange={handlePageChange}
        onRowsPerPageChange={handleLimitChange}
        page={page}
        rowsPerPage={limit}
        rowsPerPageOptions={ROW_PER_PAGE_OPTIONS}
      />
      <KhophieuView open={openKhophieuView} handleClose={handleCloseKhophieuView} khos={_khos} khophieu={_khophieu} />
      <CreateEditDialog open={open} handleClose={handleClose} type={"EDIT"} />
      <ConfirmDialog open={confirm} title={title} content={content || `Xác nhận xoá bản ghi `} highlight={selected.id} handleClose={handleConfirmClose} handleConfirm={onConfirm} />
    </Card>
  );
};

export default KhoLookupDetail;
